import { useIntl } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import {
	useV2SupportedDestinationsWarningModalHashes,
	type V2FTSupportedDestinationsWarningModalFooterProps,
	v2SupportedDestinationsModalConfirmDisabledAtom
} from '@capsicum/features/nc-wallet/shared';
import { useAtomValue } from 'jotai';

export const V2FTSupportedDestinationsWarningModalFooter = ({
	asset,
	close,
	hash,
	onSubmit
}: V2FTSupportedDestinationsWarningModalFooterProps) => {
	const { $t } = useIntl();

	const { setHash } = useV2SupportedDestinationsWarningModalHashes();
	const isDisabled = useAtomValue(v2SupportedDestinationsModalConfirmDisabledAtom);

	return (
		<Button
			disabled={isDisabled}
			fullWidth
			testID="V2FTSupportedDestinationsWarningModalFooter-continue-button"
			text={$t('global.button.continue')}
			onClick={() => {
				onSubmit();
				close();
				asset.assetId && setHash(asset.assetId, hash);
			}}
		/>
	);
};
